import React from "react";
import { Box, Typography } from "@mui/material";
import Flippy, { FrontSide, BackSide } from "react-flippy";

const Card = ({ icon, title, content, link, content2, image }) => {
	return (
		<Flippy
			flipOnHover={false}
			flipOnClick={true}
			flipDirection="horizontal"
			style={{
				borderRadius: "20px",
				width: "90%",
				height: "250px",
				cursor: "pointer",
				marginLeft: "auto",
				marginRight: "auto",
			}}
		>
			<FrontSide
				style={{
					boxShadow: "none",
					border: "1px solid lightgray",
					borderRadius: "20px",
					position: "relative",
				}}
			>
				{icon}
				<Box sx={{ pt: 1, fontWeight: "900" }}>{title}</Box>
				<Box sx={{ pt: 2, lineHeight: "1.4em", fontSize: "16px" }}>
					{content}
				</Box>
				<Box sx={{ position: "absolute", bottom: 20 }} color="secondary">
					Learn more &#62;
				</Box>
			</FrontSide>
			<BackSide
				style={{
					boxShadow: "none",
					border: "1px solid lightgray",
					borderRadius: "20px",
					lineHeight: "1.4em",
				}}
			>
				<Box
					sx={{
						backgroundImage: `url("${image}")`,
						width: 1,
						height: "135px",
						backgroundSize: "100% 100%",
						backgroundPosition: "cover",
						borderRadius: "20px",
						mb: 2,
						lineHeight: "1.5em",
					}}
				></Box>
				{content2}
			</BackSide>
		</Flippy>
	);
};

export default Card;
